import { ChangeDetectionStrategy, Component } from '@angular/core'
import * as EventTicketsActions from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.actions'
import { EventTicketsFacade } from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.facade'
import { ActivatedRoute } from '@angular/router'
import { EventTicketEntity } from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.models'
import { EventTicketGuestStatusEnum } from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'gb-event-ticket-decline-dialog',
  templateUrl: './gb-event-ticket-decline-dialog.component.html',
  styleUrls: ['./gb-event-ticket-decline-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbEventTicketDeclineDialogComponent {
  selectedEventTicket$ = this.eventTicketsFacade.selectedEventTicket$

  get token(): string | undefined {
    return this.route.snapshot.queryParams['token']
  }

  constructor(
    private eventTicketsFacade: EventTicketsFacade,
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) {}

  /**
   * Returns either 'Cancel' or 'Decline' based on the status of the event ticket
   */
  getActionTranslation(eventTicket: EventTicketEntity): string {
    const actionKey =
      eventTicket.guest_status === EventTicketGuestStatusEnum.Accepted
        ? 'EVENT_TICKET.DECLINE_TICKET.CANCEL'
        : 'EVENT_TICKET.DECLINE_TICKET.DECLINE'
    return this.translateService.instant(actionKey)
  }

  onSubmit(): void {
    this.eventTicketsFacade.dispatch(EventTicketsActions.declineEventTicket({ token: this.token }))
  }

  openEventTicketAcceptDialog(): void {
    this.eventTicketsFacade.dispatch(EventTicketsActions.openEventTicketAcceptDialog())
  }
}
